import React, { useEffect } from 'react';
import { Typography } from '@/UI/Components/Typography/Typography';

const Invitation: React.FC = () => {
	useEffect(() => {
		const handleRedirect = () => {
			try {
				const urlParams = new URLSearchParams(window.location.search);
				const token = urlParams.get('token');
				const locale = urlParams.get('locale') || 'es';

				if (token) {
					const baseUrl = import.meta.env.VITE_CC_BASE_URL || 'https://admin.fincluyente.com.mx';
					window.location.href = `${baseUrl}/${locale}/confirm_invite?token=${token}`;
				}
			} catch (err) {
				console.error(err);
			}
		};
		handleRedirect();
	}, []);

	return (
		<div className="bg-[#1E6091]">
			<div className="w-full h-screen flex flex-col justify-center items-center">
				<div className="flex flex-col items-center justify-center w-full max-w-[80%] md:max-w-[50%] text-center grow">
					<div className="flex-1 flex flex-col items-center justify-center gap-6 bg-white p-5 md:p-10 max-h-[60%] md:max-h-[50%] rounded-lg">
						<div className="w-full flex flex-col gap-2 items-center">
							<div className="w-28 items-center">
								<img src="/black-logo.png" alt="Fincluyente" />
							</div>
							<Typography size={22} weight="bold" color="black">
								Redirigiendo a Centro de comando
							</Typography>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Invitation;
